import React from "react"

// antd
import { Typography, Button, message, Drawer, Divider } from "antd"

// firebase
import { Auth } from "services/firebase"
import { signOut } from "firebase/auth"

// store
import { ArrowLeftOutlined, LogoutOutlined } from "@ant-design/icons"

// i18n
import { useTranslation } from "react-i18next"

const MenuDrawerLogout = ({ onClose, open, onLogout }) => {
  const { t } = useTranslation()
  const [messageApi, contextHolder] = message.useMessage()

  const [state, setState] = React.useState("idle")

  return (
    <div>
      {contextHolder}

      <Drawer
        title={t("menu")}
        closeIcon={<ArrowLeftOutlined style={{ fontSize: 20 }} />}
        placement="right"
        onClose={onClose}
        open={open}
      >
        <Typography.Title level={4}>{t("sign_out_title")}</Typography.Title>

        <Typography.Paragraph>{t("sign_out_confirm")}</Typography.Paragraph>

        <Divider />

        <Button
          type="primary"
          block
          onClick={onClose}
          style={{ marginBottom: 16 }}
        >
          {t("cancel")}
        </Button>

        <Button
          icon={<LogoutOutlined />}
          loading={state === "loading"}
          type="primary"
          block
          danger
          onClick={() => {
            setState("loading")
            signOut(Auth)
              .then(() => {
                setState("idle")
                messageApi.success(t("signed_out"))
                onLogout()
              })
              .catch((e) => messageApi.error(e.message))
              .finally(() => setState("idle"))
          }}
        >
          {t("sign_out_title")}
        </Button>
      </Drawer>
    </div>
  )
}

export default MenuDrawerLogout
